module.exports = __webpack_public_path__ + "static/media/home.6d164950.png";